import { useEffect, useState } from "react";
import api from "../api/api";
import CategoryShowcase from "../components/CategoryShowcase";
import Loader from "../components/Loader";
import EmptyState from "../components/EmptyState";
import { getCached, setCached, isFresh } from "../utils/apiCache";
import "../styles/components/home.scss";

// Fixed display order for the four permanent root categories.
const ROOT_ORDER = ["Products", "3D Printers", "Filaments", "Accessories"];
const CACHE_KEY = "categories";

function toRoots(data) {
  return data
    .filter((category) => !category.parent_id)
    .sort((a, b) => ROOT_ORDER.indexOf(a.name) - ROOT_ORDER.indexOf(b.name));
}

function Home() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const cached = getCached(CACHE_KEY);
    if (cached) {
      setCategories(toRoots(cached.data));
      setLoading(false);
    }

    // Revalidate whenever the cache is missing or stale - if we already
    // showed a cached list above, this refreshes it silently in the
    // background instead of showing a loading state again.
    if (!isFresh(cached)) {
      api
        .get("/categories")
        .then((res) => {
          if (!active) return;

          const data = Array.isArray(res.data?.data) ? res.data.data : [];
          setCached(CACHE_KEY, data);
          setCategories(toRoots(data));
        })
        .catch((err) => {
          console.error(err);
          if (active && !cached) setError("Unable to load categories");
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    }

    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="home-state">
        <Loader message="Loading..." />
      </div>
    );
  }

  if (error || categories.length === 0) {
    return (
      <div className="home-state">
        <EmptyState
          message={error || "No categories to show yet"}
          variant={error ? "error" : "empty"}
        />
      </div>
    );
  }

  return <CategoryShowcase categories={categories} />;
}

export default Home;
